import React, { memo, useEffect } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './SimPopup.module.less';
import { setSIMPopupInfo } from '../../actions/asimstatus';
import { installAndroidSoft } from '../../actions/anative';
import { logging } from '../../actions/log';

const SelectSIMPopupInfo = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.SIMPopupInfo,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const SIMPopupInfo = useSelector(SelectSIMPopupInfo);
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    // 展示打桩
    dispatch(
      logging({
        category: 'Simulate',
        action: 'Install',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, []);
  const handleClose = type => {
    dispatch(setSIMPopupInfo(null));
    const eventClose = {
      cancel: 'Install_No',
      close: 'Install_Close',
    };
    if (type) {
      // 点击暂不安装打桩
      dispatch(
        logging({
          category: 'Simulate',
          action: eventClose[type],
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  };
  const handleInstall = () => {
    const softInfo = { ...SIMPopupInfo };
    dispatch(installAndroidSoft(softInfo));
    // 点击继续安装
    dispatch(
      logging({
        category: 'Simulate',
        action: 'Install_Yes',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    handleClose();
  };
  return (
    <div className={styles.mask}>
      <div className={styles.popUp}>
        <div className={styles.popUp_close}>
          <span
            className="icon"
            onClick={() => {
              handleClose('close');
            }}
          >
            <i className={classNames('iconfont icon-sim_close ', styles.icon_sim)} />
          </span>
        </div>
        <div className={styles.popUp_header}>温馨提示</div>
        <div className={styles.popUp_title}>安卓游戏运行需要模拟器支持</div>
        <div className={styles.popUp_content}>
          我们将为你安装联想模拟器，以支持手机游戏在PC上的畅玩体验。是否继续？
        </div>
        <div className={styles.popUp_button}>
          <div className={styles.btn_row}>
            <div
              className={classNames(styles.button, styles.uninstall)}
              onClick={() => {
                handleClose('cancel');
              }}
            >
              暂不安装
            </div>
            <div className={classNames(styles.button, styles.install)} onClick={handleInstall}>
              继续安装
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
